import { Company, CompanySubset, AccountingYear } from 'app/api/company.api.service';
import { CallState } from 'app/utils/callstate';
import { EntityState } from '@ngrx/entity';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { CompanyFilterInput } from 'app/api/API.service';
import * as moment from 'moment';

export interface Period {
    from: AccountingYear;
    to?: AccountingYear;
    key?: string;
    value?: string;
    keyStringFilterInput?: KeyStringFilterInput;
}

export interface CompanyState {
    company: Company;
    callState: CallState;
}

export interface CompaniesState extends EntityState<CompanySubset> {
    key?: KeyStringFilterInput;
    callState: CallState;
}

export interface CompaniesUIState {
    filter: CompanyFilterInput;
    currentCompanyId: string;
    currentCompanyIdChanged: boolean;
    currentPeriod: Period;
    currentPeriodChanged: boolean;
}

export const formatStartDate = (year: AccountingYear, format = 'YYYY-MM'): string =>
    (year && year.startDate) ? moment.utc(year.startDate).format(format) : '';

export const displayStartDate = (year: AccountingYear): string => {
    const startDate = formatStartDate(year, 'MMMM YY');
    return startDate !== '' ? startDate.charAt(0).toUpperCase() + startDate.slice(1) : '';
};
